import { ArrowUpRight } from "lucide-react";
import { SEO } from "../components/SEO";
import { MaskedLines, FadeUp, Overline, GoldRule } from "../components/Reveal";
import { SITE } from "../data/site";

const About = () => (
  <div data-testid="about-page">
    <SEO
      title="Licensed Esthetician in Orlando, FL | Lunar Ambitions"
      description="Meet Alena, a licensed esthetician in Orlando, FL specializing in customized facials, microneedling, and skin care treatments for acne, aging, and uneven skin tone. Originally from Kiev, Ukraine, trained in advanced clinical techniques."
    />

    <section className="relative overflow-hidden bg-white pt-52 pb-24 lg:pt-72 sm:pb-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-14 lg:gap-16 items-center">
        <div className="lg:col-span-6">
          <Overline>Lunar Ambitions · Orlando, FL</Overline>
          <h1
            className="mt-6 font-display font-normal tracking-tight leading-[1.06] text-navy text-4xl sm:text-5xl lg:text-6xl"
            data-testid="about-heading"
          >
            <MaskedLines lines={["Meet Alena"]} />
          </h1>
          <FadeUp delay={0.4}>
            <GoldRule className="mt-10 w-24" />
            <p
              className="mt-10 text-base sm:text-lg text-navy/75 leading-relaxed font-light"
              data-testid="about-paragraph-1"
            >
              Hi, I'm Alena, a licensed esthetician from Kiev, Ukraine and based
              in Orlando, FL. Trained in advanced clinical techniques rooted in
              the meticulous approaches common in European skincare, I apply a
              high standard of skincare to every treatment.
            </p>
            <p
              className="mt-6 text-base sm:text-lg text-navy/75 leading-relaxed font-light"
              data-testid="about-paragraph-2"
            >
              I believe in science-backed methods with a deep, personal touch.
              Every session is customized to your skin's unique needs, whether
              you're a man or woman, targeting acne, aging, uneven tone, or
              simply want to maintain your already gorgeous glow.
            </p>
            <p
              className="mt-6 text-base sm:text-lg text-navy/75 leading-relaxed font-light"
              data-testid="about-paragraph-3"
            >
              I am deeply passionate about educating my clients on long-term
              skin health and building routines that actually work.
            </p>
            <a
              href={SITE.bookingGeneral}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="about-book-consultation-button"
              className="group mt-10 inline-flex items-center gap-3 bg-navy text-white text-sm tracking-[0.16em] uppercase font-medium px-9 py-4 transition-colors duration-300 hover:bg-gold hover:text-navy"
            >
              Book a consultation
              <ArrowUpRight
                size={16}
                className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </a>
          </FadeUp>
        </div>
        <div className="lg:col-span-6">
          <FadeUp delay={0.25}>
            <div className="relative max-w-md mx-auto lg:ml-auto">
              <div
                aria-hidden="true"
                className="absolute -inset-3 border border-gold/40 translate-x-4 translate-y-4"
              />
              <div className="relative overflow-hidden aspect-[1027/1540] shadow-[0_40px_80px_-40px_rgba(4,46,100,0.4)]">
                <img
                  src="/images/alena-esthetician-orlando.jpg"
                  alt="Alena, licensed esthetician and owner of Lunar Ambitions in Orlando FL, holding a facial massage tool and skin care product in her professional treatment studio."
                  className="w-full h-full object-cover transition-transform duration-700 hover:scale-105"
                  data-testid="about-image"
                />
              </div>
            </div>
          </FadeUp>
        </div>
      </div>
    </section>
  </div>
);

export default About;
